import {
    PUT_HISTORY_ITEMS
} from "../actions/itemHistory";

const initialState = {
    historyItems: []
}

export default function getsHistoryItems(state = initialState, action) {
    switch (action.type) {

        case PUT_HISTORY_ITEMS:
            console.log('getsHistoryItems->action', action);
            return {
                ...state,
                historyItems: action.historyItems,
            }
            break;

        default:
            return state;
    }


}